import React, { Component } from 'react'
import { audioRecorderTypes } from '../../utils'
import { Loading } from '../../misc'
import {
    formHandler,
    Button,
    Select,
    TextInput,
} from '../../ui'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as gearActions from '../../../actions/gear'

class AudioRecorderSelectionForm extends Component {
    constructor(props) {
        super(props)

        this.state = { data: this.props.data }

        this._updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        if (! this.props.gear.audio_recorder_makes) {
            this.props.gearActions.loadAudioRecorderMakes()
        }
    }

    _submitAudioRecorderData = () => {
        const data = {
            recorder_type: this.state.data.recorder_type,
            make: this.state.data.make,
            model: this.state.data.model,
            channels: this.state.data.channels,
        }

        this.props.gearActions.submitAudioRecorder(
            data,
            this.props.crew_uuid,
            this.state.data.uuid
        )
    }

    _transformrecorderMakes() {
        if (this.props.gear.audio_recorder_makes) {
            return this.props.gear.audio_recorder_makes.map((make) => {
                return {
                    label: make.name,
                    value: make.uuid,
                }
            })
        }

        return []
    }

    render() {
        if (! this.props.gear.audio_recorder_makes) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        return (
            <div>
                <p>
                    Can&apos;t find your make? Email&nbsp;
                    <a href="mailto:gear@hayden5.com">gear@hayden5.com</a> to tell us about your equipment type.
                </p>

                <Select
                    error={ errors.recorder_type }
                    name="recorder_type"
                    options={ audioRecorderTypes() }
                    placeholder="Select audio recorder/mixer type"
                    updateValue={ this._updateValue }
                    value={ this.state.data.recorder_type }
                />
                <Select
                    error={ errors.make }
                    name="make"
                    options={ this._transformrecorderMakes() }
                    placeholder="Select audio recorder/mixer make"
                    updateValue={ this._updateValue }
                    value={ this.state.data.make }
                />
                <TextInput
                    error={ errors.model }
                    name="model"
                    placeholder="Enter audio recorder/mixer model"
                    updateValue={ this._updateValue }
                    value={ this.state.data.model }
                />
                <TextInput
                    error={ errors.channels }
                    name="channels"
                    placeholder="Enter total audio channels this audio recorder/mixer supports"
                    type="number"
                    updateValue={ this._updateValue }
                    value={ this.state.data.channels }
                />

                <Button
                    buttonOnly
                    loading={ this.props.appState.loading }
                    onClick={ this._submitAudioRecorderData }
                    status="primary"
                >
                    Save
                </Button>
            </div>
        )
    }
}

AudioRecorderSelectionForm.propTypes = {
    appState: React.PropTypes.object,
    crew_uuid: React.PropTypes.string,
    data: React.PropTypes.object,
    gear: React.PropTypes.object,
    gearActions: React.PropTypes.object,
}

export default connect(
    (state) => {
        return {
            appState: state.appState,
            gear: state.gear,
        }
    },
    (dispatch) => {
        return {
            gearActions: bindActionCreators(gearActions, dispatch),
        }
    }
)(AudioRecorderSelectionForm)



// WEBPACK FOOTER //
// ./app/components/gear/modals/audio_recorder_selection_form.js